export function clickById(fileInputId) {
    const input = document.getElementById(fileInputId);
    input ? input.click() : console.error(`Erro: elemento input de id='${fileInputId}' não existe na página.`);
}

export function switchElementDisplayById(prefix, postfix, display='flex') {
    const id = prefix + postfix;
    let elem = document.getElementById(id);
    if (elem.style.display === display) {
        elem.style.display = 'none';
    } else {
        elem.style.display = display;
    }
}

export function swapItemsDisplayById(prefix_a, prefix_b, postfix, display='flex') {
    let id_a = prefix_a + postfix;
    let id_b = prefix_b + postfix;

    let elem_a = document.getElementById(id_a);
    let elem_b = document.getElementById(id_b);

    if (elem_a.style.display === 'none') {
        elem_a.style.display = display;
    } else {
        elem_a.style.display = 'none';
    }

    if (elem_b.style.display === 'none') {
        elem_b.style.display = display;
    } else {
        elem_b.style.display = 'none';
    }
}

export function updateCookieList(origCookieStr, newCookieStr) {
    const prodIDs = origCookieStr.split(',');
    prodIDs.unshift(newCookieStr);
    if (prodIDs.length > 4) prodIDs.pop();
    return prodIDs.toString();
}
